// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateTeamMarketingProfileAboutSection(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfileAboutSectionUpdated"]);
}

let variablesConverter = {"updateTeamMarketingProfileAboutSectionInput":{"about":{"b":""}},"__root":{"input":{"r":"updateTeamMarketingProfileAboutSectionInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateTeamMarketingProfileAboutSection_TeamMarketingProfileAboutSectionUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileAboutSection":{"u":"response_updateTeamMarketingProfileAboutSection"}}};

let wrapResponseConverterMap = {
  response_updateTeamMarketingProfileAboutSection: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateTeamMarketingProfileAboutSection_TeamMarketingProfileAboutSectionUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileAboutSection":{"u":"response_updateTeamMarketingProfileAboutSection"}}};

let responseConverterMap = {
  response_updateTeamMarketingProfileAboutSection: unwrap_response_updateTeamMarketingProfileAboutSection
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileAboutSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileAboutSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileAboutSettings_form_teamMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileAboutSectionUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamMarketingProfileAboutSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileAboutSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "about",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileAboutSectionUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c51cb98d8dc47c03a36f67613a7a2cb",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileAboutSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation TeamMarketingProfileAboutSettingsMutation(\n  $input: UpdateTeamMarketingProfileAboutSectionInput!\n) {\n  updateTeamMarketingProfileAboutSection(input: $input) {\n    __typename\n    ... on TeamMarketingProfileAboutSectionUpdated {\n      marketingProfile {\n        ...TeamMarketingProfileAboutSettings_form_teamMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment TeamMarketingProfileAboutSettings_form_teamMarketingProfile on TeamMarketingProfile {\n  about\n  publicUrl\n}\n"
  }
};
})());

let wrap_response_updateTeamMarketingProfileAboutSection = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateTeamMarketingProfileAboutSection = unwrap_response_updateTeamMarketingProfileAboutSection;
exports.wrap_response_updateTeamMarketingProfileAboutSection = wrap_response_updateTeamMarketingProfileAboutSection;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
